import { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { path } from '../../paths';
import { onBasePath } from '../../paths/onBasePath';
import { SampleDirectory } from './SampleDirectory';
import { SampleDetail } from './SampleDetail';

import translations from './Samples.translations.json';
import { NotFound } from '../NotFound';

export const { addTranslations, Translation } = i18nNsFactory('samples-page');
addTranslations(translations);

export const SAMPLE_ROUTES = [
  {
    path: path.sampleDirectory,
    renderBreadcrumb: () => (
      <Translation>{(t) => t('breadcrumb.samples')}</Translation>
    ),
    children: [
      {
        index: true,
        element: <SampleDirectory />,
      },
      {
        path: path.sampleView,
        element: <SampleDetail />,
        renderBreadcrumb: (data?: string) => data,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export const Samples: FC<{ basePath: string }> = ({ basePath }) =>
  useRoutes(onBasePath(basePath, SAMPLE_ROUTES));
